import { useEffect, useMemo, useState } from 'react';

function startAt(order) {
  return order?.preparingAt || order?.acceptedAt || order?.createdAt || Date.now();
}

export default function useOrderTimer(order) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  return useMemo(() => {
    const started = new Date(startAt(order)).getTime();
    if (!Number.isFinite(started)) return 0;
    return Math.max(0, Math.floor((now - started) / 60000));
  }, [now, order]);
}
